import api from "../api/axios";
import ENDPOINTS from "../api/endpoints";

export const createUserBooking = async (payload) => {
  const response = await api.post(ENDPOINTS.BOOKINGS.USER, payload);
  return response.data;
};

export const bookAsUser = createUserBooking;
export const createBookingForUser = createUserBooking;

export const createGuestBooking = async (payload) => {
  const response = await api.post(ENDPOINTS.BOOKINGS.GUEST, payload);
  return response.data;
};

export const bookAsGuest = createGuestBooking;
export const createBookingForGuest = createGuestBooking;

export const getBookingById = async (id) => {
  const response = await api.get(ENDPOINTS.BOOKINGS.BY_ID(id));
  return response.data;
};

export const getBookingsByUserId = async (userId) => {
  const response = await api.get(ENDPOINTS.BOOKINGS.BY_USER_ID(userId));
  return response.data;
};

export const getBookingsByUser = getBookingsByUserId;
export const getUserBookings = getBookingsByUserId;

export const getBookingByConfirmationCode = async (code) => {
  const response = await api.get(ENDPOINTS.BOOKINGS.BY_CONFIRMATION(code));
  return response.data;
};

export const getAllBookings = async () => {
  const response = await api.get(ENDPOINTS.BOOKINGS.ALL);
  return response.data;
};

export const getBookings = getAllBookings;
export const getAllAdminBookings = getAllBookings;

export const getBookingsByDate = async (date) => {
  const response = await api.get(ENDPOINTS.BOOKINGS.BY_DATE(date));
  return response.data;
};

export const getBookingsByStatus = async (status) => {
  const response = await api.get(ENDPOINTS.BOOKINGS.BY_STATUS(status));
  return response.data;
};

export const cancelBookingById = async (id) => {
  const response = await api.post(ENDPOINTS.BOOKINGS.CANCEL_BY_ID(id));
  return response.data;
};

export const cancelBooking = cancelBookingById;

export const cancelBookingByConfirmationCode = async (code) => {
  const response = await api.post(
    ENDPOINTS.BOOKINGS.CANCEL_BY_CONFIRMATION(code)
  );
  return response.data;
};

export const completeBooking = async (id) => {
  const response = await api.post(ENDPOINTS.BOOKINGS.COMPLETE(id));
  return response.data;
};

export const markBookingCompleted = completeBooking;

const bookingService = {
  createUserBooking,
  bookAsUser,
  createBookingForUser,
  createGuestBooking,
  bookAsGuest,
  createBookingForGuest,
  getBookingById,
  getBookingsByUserId,
  getBookingsByUser,
  getUserBookings,
  getBookingByConfirmationCode,
  getAllBookings,
  getBookings,
  getAllAdminBookings,
  getBookingsByDate,
  getBookingsByStatus,
  cancelBookingById,
  cancelBooking,
  cancelBookingByConfirmationCode,
  completeBooking,
  markBookingCompleted,
};

export default bookingService;